import { combineReducers } from 'redux';
import { IMAGE_UPDATED, IMAGE_DELETED } from '../actions/images';
import { INITIAL_DATA_LOAD_SUCCESS } from '../actions';

const strategies = (state = {}, action) => {
  switch (action.type) {
    case INITIAL_DATA_LOAD_SUCCESS:
      return {
        image: action.strategy,
      };
    default:
      return state;
  }
};

const resources = (state = {}, action) => {
  switch (action.type) {
    case INITIAL_DATA_LOAD_SUCCESS:
      return {
        image: action.image,
        catchImage: action.catchImage,
      };
    case IMAGE_UPDATED:
      return {
        ...state,
        image: action.image,
      };
    case IMAGE_DELETED:
      return {
        ...state,
        image: undefined,
      };
    default:
      return state;
  }
};

export default combineReducers({
  strategies,
  resources,
});

export const getImageStrategy = state => state.images.strategies.image;
export const getImage = state => state.images.resources.image;



// WEBPACK FOOTER //
// ./src/modules/calendar/reducers/images.js